import { Fragment } from 'react';
import type { ReactElement, ReactNode } from 'react';

export interface KeyValueRow {
  readonly label: string;
  readonly value: ReactNode;
  readonly key?: string;
}

export interface KeyValueProps {
  readonly rows: readonly KeyValueRow[];
}

/**
 * Definition list used for every "label: value" block. It collapses to a
 * single column below 420px so nothing is clipped on a narrow phone.
 */
export function KeyValue({ rows }: KeyValueProps): ReactElement {
  return (
    <dl className="kv">
      {rows.map((row) => (
        <Fragment key={row.key ?? row.label}>
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
